__turbopack_context__.v({
  "dialog": "_3myLNG_dialog",
  "dialogSuccess": "_3myLNG_dialogSuccess",
  "errorContactWrapper": "_3myLNG_errorContactWrapper",
  "errorMessageWrapper": "_3myLNG_errorMessageWrapper",
  "formWrapper": "_3myLNG_formWrapper",
  "phoneFieldWrapper": "_3myLNG_phoneFieldWrapper",
  "wrapper": "_3myLNG_wrapper",
});
